export const HEADER_LABELS = 'global.header';

export const lblYuySaving = 'lbl_Yuy_saving';
export const lblCouponValidity = 'lbl_coupon_validity';
export const lblCreateAnAccount = 'lbl_create_an_account';
export const lblDatePicker = 'lbl_date_picker';
export const lblDetailsTxt = 'lbl_detailsTxt';
export const lblEarnedRewardText = 'lbl_earnedReward_text';
export const lblEarnedIt = 'lbl_earned_it';
export const lblFallbackRewardText = 'lbl_fallbackReward_text';
export const lblFavorites = 'lbl_favorites';
export const lblGuestPromoTxt = 'lbl_guest_promo_txt';
export const lblHeaderBgImageDesktopUrl = 'lbl_header_bgImage_desktop_url';
export const lblHeaderBgImageMobileUrl = 'lbl_header_bgImage_mobile_url';
export const lblHeaderHelloText = 'lbl_header_helloText';
export const lblHeaderHiTxt = 'lbl_header_hiTxt';
export const lblHeaderInYourBagTitle = 'lbl_header_inYourBagTitle';
export const lblHeaderLogin = 'lbl_header_login';
export const lblHeaderMyFavorite = 'lbl_header_myFavorite';
export const lblHeaderNewLogin = 'lbl_header_new_login';
export const lblHeaderOpenUntil = 'lbl_header_openUntil';
export const lblHeaderSeeYouAgainText = 'lbl_header_seeYouAgainText';
export const lblHeaderStoreDefaultTitle = 'lbl_header_storeDefaultTitle';
export const lblHeaderStoreTitle = 'lbl_header_storeTitle';
export const lblHeaderTrackOrder = 'lbl_header_trackOrder';
export const lblHeaderWelcomeMessage = 'lbl_header_welcomeMessage';
export const lblMyOffersTxt = 'lbl_myOffers_txt';
export const lblNextRewardText = 'lbl_nextReward_text';
export const lblPreviewDate = 'lbl_preview_date';
export const lblProgressGuestTxt = 'lbl_progress_guest_txt';
export const lblRedeemCheckout = 'lbl_redeem_checkout';
export const lblRefreshData = 'lbl_refresh_data';
export const lblShopThisStoreNotificationMessage = 'lbl_shopThisStore_notificationMessage';
export const lblShopThisStoreSearch = 'lbl_shopThisStore_search';
export const lblShopThisStoreShopAt = 'lbl_shopThisStore_shopAt';
export const lblShopThisStoreShopOnline = 'lbl_shopThisStore_shopOnline';
export const lblShopThisStoreStoreChange = 'lbl_shopThisStore_storeChange';
export const lblStoreldetailsClosed = 'lbl_storeldetails_closed';
export const lblTimePicker = 'lbl_time_picker';
export const lblUsebyTxt = 'lbl_useby_txt';
export const lblUserRewardTxt = 'lbl_user_reward_txt';
export const lblValidtxt = 'lbl_validtxt';
export const lblViewTxt = 'lbl_viewTxt';
export const lblSavedTo = 'lbl_saved_to';

export const headerLabels = {
  global: {
    header: {
      [lblYuySaving]: 'Yay for savings!',
      [lblCouponValidity]: 'Validity',
      [lblCreateAnAccount]: 'Create an Account',
      [lblDatePicker]: 'Show Date Picker',
      [lblDetailsTxt]: 'Details',
      [lblEarnedRewardText]: 'CONGRATULATIONS YOU HAVE EARNED #estimatedRewardsVal# REWARD',
      [lblEarnedIt]: 'You earned it!',
      [lblFallbackRewardText]: 'YOU HAVE EARNED POINTS ON THIS PURCHASE!',
      [lblFavorites]: 'Your Wishlist',
      [lblGuestPromoTxt]: 'Earn points every time you shop!',
      [lblHeaderBgImageDesktopUrl]:
        'https://assets.theplace.com/image/upload/f_auto,q_auto/ecom/assets/content/gym/us/place-bucks/place_bucks.png',
      [lblHeaderBgImageMobileUrl]:
        'https://assets.theplace.com/image/upload/f_auto,q_auto/ecom/assets/content/gym/us/place-bucks/place_bucks.png',
      [lblHeaderHelloText]: 'Hello',
      [lblHeaderHiTxt]: 'Hi',
      [lblHeaderInYourBagTitle]: 'In Your Bag',
      [lblHeaderLogin]: 'Login',
      [lblHeaderMyFavorite]: 'My Wishlists',
      [lblHeaderNewLogin]: 'Log In',
      [lblHeaderOpenUntil]: 'open until',
      [lblHeaderSeeYouAgainText]: 'Nice to see you again!',
      [lblHeaderStoreDefaultTitle]: 'Find a Store',
      [lblHeaderStoreTitle]: 'Your Store',
      [lblHeaderTrackOrder]: 'Track Orders',
      [lblHeaderWelcomeMessage]: 'Welcome!',
      [lblMyOffersTxt]: 'MY OFFERS',
      [lblNextRewardText]: 'points away from earning your next reward.',
      [lblPreviewDate]: 'Select scheduled preview date',
      [lblProgressGuestTxt]: 'You can earn #estimatedRewardsVal#',
      [lblRedeemCheckout]: 'Redeem at Checkout.',
      [lblRefreshData]: 'Refresh Data',
      [lblShopThisStoreNotificationMessage]: 'You are no longer shopping products from',
      [lblShopThisStoreSearch]: 'Search items at this location',
      [lblShopThisStoreShopAt]: 'Shopping at',
      [lblShopThisStoreShopOnline]: 'Switch to Online',
      [lblShopThisStoreStoreChange]: 'Change Store',
      [lblStoreldetailsClosed]: 'Closed',
      [lblTimePicker]: 'Show Time Picker',
      [lblUsebyTxt]: 'Use by',
      [lblUserRewardTxt]: "You're #estimatedRewardsVal# #descVal#",
      [lblValidtxt]: 'Valid',
      [lblViewTxt]: 'View',
      [lblSavedTo]: 'Saved to:',
    },
  },
};
